export class GlobalDisableSettings {
  disableHELevelsAllQuery?: boolean;
  disableSingleAppAttributeQuery?: boolean;
  disableEventChart?: boolean;
  disableUoMQuery?: boolean;
}
